﻿$.fn.dxCtrlChartTauxReactivite = function custom_dxCtrlChartTauxReactivite(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcharttauxreactivite dx-ctrl");
        this.createInstance(new cdxCtrlChartTauxReactivite(this, option));
    }
    return this;
}

window.cdxCtrlChartTauxReactivite = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty()
        container.css({ "height": "100%", "width": "100%" })
        Me.mUpdate()
    }

    function mRempli(value, data) {
        var messPlus = ((data.nb_click == 0) ? "aucune réactivité" : "Taux réactivité")
        if (dx == null) {
            dx = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlStrConIndicReactivite({
                bddCtrl: option.bddCtrl,
                data: data,
                large: true
            }).dxCtrlStrConIndicReactivite("instance")
            //dx = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlIndicateurCircle({
            //    value: value,
            //    messagePlus: messPlus
            //}).dxCtrlIndicateurCircle("instance")
        } else {
            dx.mUpdate(value)
        }
    }

    this.mUpdate = function (data) {
        if (typeof data == 'undefined') {
            option.bddCtrl.mAjaxCall({ command: "getresumeenvoi", id_table_com: option.idTableCom, id_com: option.idCom },
                function (data) {
                    Me.mUpdate(data.stat[0])
                })
        } else {
            var value = 0
            if (option.idTableCom == option.bddCtrl.getObjet("com_email_envoi").mGetTable().id_table) {
                if (data.nb_vue > 0) value = ((parseInt(data.nb_click) > parseInt(data.nb_vue)) ? 100 : Math.ceil(data.nb_click / data.nb_vue))
            } else {
                if (data.nb_total > 0) value = ((parseInt(data.nb_click) > parseInt(data.nb_total)) ? 100 : Math.ceil(data.nb_click / data.nb_total))

            }
            data.tx_reactivite = value
            mRempli(value, data)
        }
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}